import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
// Components
import BannerOne from "../../components/BannerOne";
import IntroductionBlock from "../../components/IntroductionBlock";
// Constants
// import { TITLE, SUB_TITLE, BUTTON_NAME , BUTTON_LINK , EYE_BROWN_HEADER_CARDS, TITLE_CARDS, SUB_TITLE_CARDS, ALL_CARD_ROWS } from "./PartnerProgramConstants";
// import { EYE_BROWN_HEADER, CONTENT_BLOCKER_TITLE, CONTENT_BLOCKER_SUB_TITLE, FRAME_QUOTE, QUOTE_SIGN, QUOTE_JOB_TITLE } from "./PartnerProgramConstants";
// import { INTRO_EYE_BROWN_HEADER, INTRO_TITLE, INTRO_TEXT, SIGN_UP_TITLE, SIGN_UP_SUB_TITLE, BANNER_LINK, BUTTON_NAME_SIGN_UP } from "./PartnerProgramConstants";
// Images
import partnerProgramLogo from '../../assets/img/partnerPortal/EnablementSales/full wave.png';
import associate from '../../assets/img/partnerProgram/associate.png';
import professional from '../../assets/img/partnerProgram/professional.png';
import observability from '../../assets/img/partnerProgram/observability.png';
import cloudOpsBadge from '../../assets/img/partnerProgram/cloudOps.png';
import appDeveloperBadge from '../../assets/img/partnerProgram/appDeveloper.png';
import dynatraceMigrationBadge from '../../assets/img/partnerProgram/dynatraceMigration.png';
import devSecOpsBadge from '../../assets/img/partnerProgram/devSecOps.png';
// Scss
import '../../assets/css/partnerProgram.scss';
import '../../assets/css/partnerPortal/appDeveloper.scss';
import '../../assets/css/partnerPortal/sales.scss';

import CardWithNoBorder from "../../components/CardWithNoBorder";
import ButtonOne from "../../components/ButtonOne";

function PartnerProgramNew() {

  let history = useHistory();
  const params = useParams()["partner"];

  return (
    <>
        <BannerOne bannerImage={partnerProgramLogo} title={"PARTNER PROGRAM"} hasNoButton={true}/>

        {(params === "sales" || params === "all") ?  
        <div>
            <IntroductionBlock title={"Sales Partners"} addId="sales"  subTitle={"Increase pipeline, open new opportunities, drive revenue"} text={"Sales partners are the foundation of our incredible growth. Sales partners attain sales and platform certifications and are enabled to identify observability opportunities and attach Dynatrace observability to customer initiatives including cloud migration & modernization, digital experience management, DevOps, application security, operations automation and more."} />
            <div className="d-flex flex-column m-auto width64 ">
                <div className="howLetterSection-sub mb-3 ">
                    {"Sales Certifications"}
                </div>
                <div className="w-100 d-flex align-items-center flex-column">
                    <div className="FlexToBlock align-items-start w-100">
                        <CardWithNoBorder icon={associate} />
                        <CardWithNoBorder icon={professional} />
                        <CardWithNoBorder icon={observability} />
                    </div>
                </div>
                <div className="howLetterSection-sub mb-3 ">
                    {"Platform Certifications"}
                </div>
                <div className="w-100 d-flex align-items-center flex-column">
                    <div className="FlexToBlock align-items-start w-100">
                        <CardWithNoBorder icon={associate} />
                        <CardWithNoBorder icon={professional} />
                        <CardWithNoBorder icon={observability} />
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                <ButtonOne target="_blank" text={"See all Sales Partners"} classNameOfA={"width24"} className={"pad7"}  link={"https://www.dynatrace.com/partners/solution-partners/"} withoutIcon={true} />
                </div>
            </div>
        </div> : ""}

        {(params === "services" || params === "all") ? 
        <div>
            <IntroductionBlock title={"Services Partners"} addId="services"  subTitle={"Build and deliver in-demand services offerings"} text={"Sales partners with Professional certifications can elevate their status to become Services Endorsed partners. Building upon platform certifications, Services partners are trained, enabled and certified to deliver services underpinned by Dynatrace’s own insights, best practices, and methodologies."} />
            <div className="d-flex flex-column m-auto width64 ">
                <div className="howLetterSection-sub mb-3 ">
                    {"Service Endorsement Certifications"}
                </div>
                <div className="w-100 d-flex align-items-center flex-column">
                    <div className="FlexToBlock align-items-start w-100">
                        <CardWithNoBorder icon={observability} />
                    </div>
                </div>
                <div className="howLetterSection-sub mb-3 ">
                    {"Specializations"}
                </div>
                <div className="w-100 d-flex align-items-center flex-column">
                    <div className="FlexToBlock align-items-start w-100">
                        <CardWithNoBorder icon={cloudOpsBadge} />
                        <CardWithNoBorder icon={appDeveloperBadge} />
                        <CardWithNoBorder icon={dynatraceMigrationBadge} />
                        <CardWithNoBorder icon={devSecOpsBadge} />
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                <ButtonOne target="_blank" text={"See all Services Partners"} classNameOfA={"width24"} className={"pad7"}  link={"https://www.dynatrace.com/partners/solution-partners/"} withoutIcon={true} />
                </div>
            </div>
        </div> : ""}

        {(params === "tech" || params === "all") ? 
        <div>
            <IntroductionBlock title={"Technology Alliances"} addId="tech-alliances"  subTitle={"Deliver advanced solutions with multi-vendor capabilities"} text={"Dynatrace and the world’s leading technology organizations unite to develop integrations, best practices, and extended capabilities that help our customers and solution partners achieve faster time to market and enhanced value."} />
            <div className="d-flex flex-column m-auto width64 ">
                <div className="d-flex align-items-center justify-content-center">
                <ButtonOne target="_blank" text={"See all Technology Alliances"} classNameOfA={"width24"} className={"pad7"}  link={"https://www.dynatrace.com/platform/cloud-monitoring/"} withoutIcon={true} />
                </div>
            </div>
        </div> : ""}
    </>
  );

}

export default PartnerProgramNew;

